import { render, staticRenderFns } from "./sjChildrenUser.vue?vue&type=template&id=e3051c86&scoped=true&"
import script from "./sjChildrenUser.vue?vue&type=script&lang=js&"
export * from "./sjChildrenUser.vue?vue&type=script&lang=js&"
import style0 from "./sjChildrenUser.vue?vue&type=style&index=0&id=e3051c86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3051c86",
  null
  
)

export default component.exports